var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCumhuriyet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.6,0c-1.9,7.4,1.5,13.8.8,20.8-.7,6.6-2.4,10.5-9.3,11.6-5.8,1-11.7,1.6-17.5,2.4-2,.3-4,.6-4.8-2-1.5-5,2.9-17.6,7.2-20.9C15.9,6.6,22.8,1.5,32.6,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumhuriyet);
export default __webpack_public_path__ + "static/media/cumhuriyet.66d93ff2dbef9177224de8ccd6b2d549.svg";
export { ForwardRef as ReactComponent };